import { Router } from '@vaadin/router';
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {storeInstance} from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import * as util from 'lib/util.js'

class KbTopicPrevnext extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
        });
        this.state = storeInstance.state
        this.string = this.state.strings;
        if(this.node){
            this.node.previousNode = util.getPrevious(this.node);
            this.node.nextNode = util.getNext(this.node);
            this.node.previousNode = this.node.previousNode ? this.node.previousNode : ''
            this.node.nextNode = this.node.nextNode ? this.node.nextNode : ''
            this.myRender()
        }
    }

    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
    }

    _loadPrevNext(node){
        var tmp1 = util.getPrevious(node)
        var tmp2 = util.getNext(node)
        this.node.previousNode = tmp1;
        this.node.nextNode = tmp2;
     }
     
    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.node){
            this.node.previousNode = util.getPrevious(this.node);
            this.node.nextNode = util.getNext(this.node);
            this.node.previousNode = this.node.previousNode ? this.node.previousNode : ''
            this.node.nextNode = this.node.nextNode ?  this.node.nextNode   : ''
            this.myRender()
            //WTF
        }
    }
    
    myRender(){
        render(this.tocItemTemplate(), this.shadowRoot);
        }
       
    tocItemTemplate(){
       return html`
            <style>
                #prevnext{
                    display:flex;
                    flex-direction: row;
                    justify-content: space-between;
                }
                .link{
                    text-decoration: underline;
                    color: var(--kb-on-surface-link-color);
                    cursor: pointer;
                }
            </style>
            <div id='prevnext'>
                <span class="link" @click="${this._itemClick.bind(this,this.node.previousNode)}">${this.node.previousNode.title ? this.string["_prev"] : ''} 
                        <!-- <span class='link'>${this.node.previousNode.title}</span> -->
                    </span> 
                <span class="link" @click="${this._itemClick.bind(this, this.node.nextNode)}">${this.node.nextNode.title ? this.string["_next"] : ''} 
                    <!-- <span class='link'>${this.node.nextNode.title}<span class='link'> -->
                </span>
            </div>
           `;
        }
    
        _itemClick(itm, e){
        if(itm.href){
            this.dispatchEvent(new CustomEvent('tocItemClicked', {
                bubbles: true,
                composed: true,
                detail: itm
                }));
        }
    }
    

}

customElements.define('kb-topic-prevnext', KbTopicPrevnext)
